import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

interface Props {
  top: number;
}

const UpgradePlanModalContainer = styled.div<Props>`
  position: fixed;
  width: ${1920 * Screen.widthRatio}px;
  text-align: center;
  top: ${(props) => props.top * Screen.widthRatio}px;
`;

export default UpgradePlanModalContainer;
